import React, {useEffect, useContext, useMemo} from 'react';
import {Row, Col, Form, Button} from 'react-bootstrap';
import {fieldsForm, schema} from './fields'
import { useMutation } from "@apollo/client";
import useForm from 'hooks/useForm';
import RegisterContext from '../../RegisterContext';
import { UPDATE_REGISTER_DETAILS } from "schemas/register";

export default function PersonalInfo({labels, next}) {

  const {user} = useContext(RegisterContext)

  const {
    formik, 
    renderElementsForm, 
    renderElement,
    handleLoadData
  } = useForm({
      fieldsForm, 
      schema, 
      onSubmit: handleSubmit
    })

  const formElements = useMemo(() => renderElementsForm(), [fieldsForm]);

  const [saveData, { data: saveReply, error: saveError }] = useMutation(UPDATE_REGISTER_DETAILS);

  useEffect(() => {
    if (saveReply && saveReply.updateRegisterDetails) {
      if (saveReply.updateRegisterDetails.error) {
        formik.setErrors(saveReply.updateRegisterDetails.body);
      } else {
        next()
      }
    }
  }, [saveReply])

  function handleSubmit(values) {
    saveData({ variables: { data: {...values, completedStep: 1} } });
  }

  useEffect(() => {
    if (user) {
      handleLoadData(user.register)
    }
  }, [user])


    return (
        <div>
          <h3>פרטים אישיים</h3>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col>       
                {renderElement(formElements[0],labels)}
                {renderElement(formElements[1], labels)}
              </Col>
              <Col>
                {renderElement(formElements[2], labels)}
                {renderElement(formElements[3], labels)}
              </Col>
            </Row> 
            <Button aria-label="המשך" type="submit">המשך</Button>            
        </Form>
        </div>
    )
}